<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <product-form v-if="product"
          @submit="submit"
          :init-product="product"
          :val-errors="valErrors"
          submit-text="Speichern"
        />
      </card>
    </div>
  </div>
</template>

<script>
import ProductForm from './product-form'

export default {
  components: { ProductForm },
  data () {
    return {
      product: null,
      valErrors: []
    }
  },
  methods: {
    async submit (product) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.put(`/products/${product.id}`, product).then(({ data }) => {
        this.$notify({
          message: 'Produkt erfolgreich bearbeitet.',
          type: 'success'
        })
        this.redirectBack('/products')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  },
  created () {
    this.$http.get(`/products/${this.$route.params.id}`).then(({ data }) => {
      this.product = data
    })
  }
}
</script>

<style>
</style>
